import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'

import App from "./App";

// Evita overlay de erro do React para 401/403 esperados durante expiração/invalidação de sessão.
window.addEventListener("unhandledrejection", (event) => {
	const status = event?.reason?.response?.status;
	if (status === 401 || status === 403) {
		event.preventDefault();
	}
});

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

serviceworker.register()